var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 33,
    viewBox: "0 0 6 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.01 3.29C-0.03 2.88 0.01 2.46 0.15 2.06C0.28 1.66 0.49 1.29 0.77 0.98C1.05 0.67 1.39 0.42 1.78 0.25C2.16 0.08 2.58 0 3 0C3.41 0 3.83 0.08 4.21 0.25C4.6 0.42 4.94 0.67 5.22 0.98C5.5 1.29 5.71 1.66 5.84 2.06C5.98 2.46 6.02 2.88 5.98 3.29L4.82 22.34C4.77 22.8 4.56 23.22 4.22 23.52C3.89 23.82 3.45 23.99 3 23.99C2.54 23.99 2.1 23.82 1.77 23.52C1.43 23.22 1.22 22.8 1.17 22.34L0.01 3.29ZM0 30C0 29.2 0.31 28.44 0.87 27.87C1.44 27.31 2.2 27 3 27C3.79 27 4.55 27.31 5.12 27.87C5.68 28.44 6 29.2 6 30C6 30.79 5.68 31.55 5.12 32.12C4.55 32.68 3.79 33 3 33C2.2 33 1.44 32.68 0.87 32.12C0.31 31.55 0 30.79 0 30Z",
    fill: "#00A03C",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWarning);
export default __webpack_public_path__ + "static/media/ico_warning.e8813619f212a31728830c06a39a522f.svg";
export { ForwardRef as ReactComponent };